<div *ngIf="showConsent" class="fixed bottom-0 left-0 right-0 bg-white text-gray-800 shadow-2xl z-50 p-4 border-t-4 border-blue-500">
  <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between">
    <div class="mb-4 md:mb-0 md:mr-4">
      <h3 class="font-bold text-lg mb-1">We use cookies</h3>
      <p class="text-sm text-gray-600">We use cookies to improve your experience, analyze traffic, and personalize content.</p>
    </div>
    <div class="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
      <button 
        (click)="acceptNecessary()" 
        class="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors duration-200 text-sm">
        Accept necessary
      </button>
      <button 
        (click)="acceptAll()" 
        class="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 text-sm">
        Accept all
      </button>
    </div>
  </div>
</div>